import EventSettingsRow from '@/components/EventSettings/EventSettingsRow'
import {
  getDVRStatus,
  getTranscoderLabel,
  hasDirectConnect,
  isUsingBackupTranscoder
} from '@/components/EventSettings/EventSettingsSettings/EventSettingsSettings.helpers'
import { StreamEvent } from '@/types/streams/event'
import { EventEncoderDetails } from '@/types/streams/eventEncoder'

import '@/styles/streamsEventSettings.css'

const EventSettingsSettings = ({
  event,
  encoderDetails
}: {
  event: StreamEvent
  encoderDetails: EventEncoderDetails
}) => {
  return (
    <>
      {event.tournament?.commentary ? (
        <EventSettingsRow col1="Commentary" col2={event.tournament.commentary} />
      ) : null}
      {event.audioLanguages ? (
        <EventSettingsRow col1="Multi-Audio" col2={event.audioLanguages} />
      ) : null}
      {event.audioTracks.tracks.length ? (
        <EventSettingsRow col1="Audio Tracks" col2={event.audioTracks.tracks.join(', ')} />
      ) : null}
      {event.captionLanguages ? (
        <EventSettingsRow col1="Closed Captions" col2={event.captionLanguages} />
      ) : null}
      {encoderDetails?.encodingEngineer?.email ? (
        <EventSettingsRow col1="Encoding Engineer" col2={getTranscoderLabel(event, false)} />
      ) : null}
      <EventSettingsRow col1="Transcoder" col2={getTranscoderLabel(event, false)} />
      {isUsingBackupTranscoder(event) ? (
        <EventSettingsRow col1="Transcoder" col2={getTranscoderLabel(event, true)} />
      ) : null}
      <EventSettingsRow col1="DVR Window" col2={getDVRStatus(event)} />
      <EventSettingsRow
        col1="Multi-CDN"
        col2={event.tournament?.property?.multiCDN ? 'Yes' : 'No'}
      />
      <EventSettingsRow
        col1="AWS Direct Connect"
        col2={hasDirectConnect(event) ? 'Enabled' : 'Disabled'}
      />
    </>
  )
}

export default EventSettingsSettings
